export const CLAM_COLORS = {
    white: '#fdfdfd',
    palidGreen: '#82b157',
    whiteGreen: '#b6d7a8',
    green: '#5a9d1e',
    lightGreen: '#6bbb24',
    greenDark: '#3f7a12',
    darkgray: '#424244',
    gray: '#6d6e71',
    lightGray: '#898a8c',
    modGreen: '#86d142',
    almostWhite: '#f0f0f0',
    danger: '#ea4335',
    success: '#6bbb24',
    surface: '#ffffff',
    surfaceSoft: '#f5f6f8',
    text: '#333333',
    textMuted: '#6d6e71',
    border: '#e2e8f0',
} as const;

export const clamThemeVars = `
:root {
    --clam-white: #fdfdfd;
    --clam-green: #5a9d1e;
    --clam-green-dark: #3f7a12;
    --clam-light-green: #6bbb24;
    --clam-palid-green: #82b157;
    --clam-white-green: #b6d7a8;
    --clam-mod-green: #86d142;
    --clam-darkgray: #424244;
    --clam-gray: #6d6e71;
    --clam-light-gray: #898a8c;
    --clam-almost-white: #f0f0f0;
    --clam-danger: #ea4335;
    --clam-success: #6bbb24;

    --clam-surface: #ffffff;
    --clam-surface-soft: #f5f6f8;
    --clam-text: #333333;
    --clam-text-muted: #6d6e71;
    --clam-border: #e2e8f0;

    --clam-primary: var(--clam-green);
    --clam-primary-hover: var(--clam-green-dark);
    --clam-on-primary: var(--clam-white);

    --clam-font: 'Inter', system-ui, -apple-system, sans-serif;

    --clam-radius-sm: 6px;
    --clam-radius-md: 8px;
    --clam-radius-lg: 12px;

    --clam-space-1: 4px;
    --clam-space-2: 8px;
    --clam-space-3: 12px;
    --clam-space-4: 16px;
    --clam-space-5: 20px;
    --clam-space-6: 24px;
    --clam-space-7: 32px;
    --clam-space-8: 40px;

    --clam-text-xs: 11px;
    --clam-text-sm: 13px;
    --clam-text-base: 14px;
    --clam-text-lg: 18px;
    --clam-text-xl: 20px;
    --clam-text-2xl: 24px;

    --clam-sidebar-width: 260px;
    --clam-topbar-height: 56px;

    --clam-bp-sm: 640px;
    --clam-bp-md: 768px;
    --clam-bp-lg: 1024px;
    --clam-touch: 44px;

    --clam-shadow-sm: 0 1px 3px rgba(0,0,0,0.08);
    --clam-shadow-md: 0 2px 8px rgba(0,0,0,0.10);
    --clam-shadow-lg: 0 4px 16px rgba(0,0,0,0.12);
}

/* Highlight de selección global (sitio público + admin panel + shadow DOM). */
::selection { background: var(--clam-green, #5a9d1e); color: #fff; }
::-moz-selection { background: var(--clam-green, #5a9d1e); color: #fff; }
`;

export function injectTheme(): void {
    if (document.getElementById('clam-theme-vars')) return;
    const style = document.createElement('style');
    style.id = 'clam-theme-vars';
    style.textContent = clamThemeVars;
    document.head.appendChild(style);
}
